export default __webpack_public_path__ + "static/media/Star_Yellow_Score.1e74018e.svg";